import BTUnreleaseFunds from '@/components/bt-unreleasefunds/BT-UnreleaseFunds'

const BTUnreleaseFundsRouter = [
  {
    path: '/BT-unreleasefunds',
    name: 'business-trip-funds-release',
    component: BTUnreleaseFunds
  }
]

export default BTUnreleaseFundsRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripUnreleaseFundsRouter.js